// Which side the profile player was on, whether it won, who it played and
// who it played with.
// Some singles sets lack a team row for one player; player1/player2 still say
// who was on which side.
export function sidesFor(match, player) {
	const teams = match.getTeamsPrioritizeMineFirst(player);
	if(teams.length >= 2) {
		return {
			teamNumber: match.getPlayerTeamNumber(player),
			won: match.playerWon(player),
			opponents: teams.slice(1).flatMap((team) => team.players),
			partners: teams[0].players.filter((teammate) => teammate.id !== player.id),
		};
	}
	if(match.player1 && match.player2) {
		const isPlayer1 = match.player1.id === player.id;
		const teamNumber = isPlayer1 ? 1 : 2;
		return { teamNumber, won: match.final_result === teamNumber, opponents: [isPlayer1 ? match.player2 : match.player1] };
	}
	return { teamNumber: match.getPlayerTeamNumber(player), won: match.playerWon(player), opponents: [] };
}

// The set score from the player's side, or null when no game was reported.
export function scoreFor(match, sides) {
	const score = match.set_score;
	if(!score || (!score.p1wins && !score.p2wins)) {
		return null;
	}
	return sides.teamNumber === 2 ? `${score.p2wins}-${score.p1wins}` : `${score.p1wins}-${score.p2wins}`;
}
